<template>
  <Bar
    v-if="loadReady"
    :chart-options="chartOptions"
    :chart-data="chartData"
    :chart-id="chartId"
    :dataset-id-key="datasetIdKey"
    :plugins="plugins"
    :css-classes="cssClasses"
    :styles="styles"
    :height="height"
  />
</template>

<script>
import { Bar } from "vue-chartjs/legacy";
import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale
} from "chart.js";

ChartJS.register(
  Title,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale
);

export default {
  name: "BarChartBasic",
  components: { Bar },
  props: {
    data: Array,
    label: String,
    width: String,
    height: String,
    chartId: {
      type: String,
      default: "bar-chart"
    },
    datasetIdKey: {
      type: String,
      default: "label"
    },
    cssClasses: {
      default: "",
      type: String
    },
    styles: {
      type: Object,
      default: () => {}
    },
    plugins: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      loadReady: false,
      chartData: {
        labels: [],
        datasets: [
          {
            label: "SS",
            backgroundColor: "#f87979",
            data: []
          }
        ]
      },
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false
      }
    };
  },
  created: function() {
    console.log();
  },
  mounted() {
    this.fillChart();
    this.loadReady = true;
  },
  methods: {
    fillChart() {
      this.data.forEach(element => {
        this.chartData.labels.push(element.eventday);
        this.chartData.datasets[0].data.push(element.eventcount);
        this.chartData.datasets[0].label = this.label;
      });
    },
  }
};
</script>
